/* eslint-disable no-case-declarations */
import {
  SET_DELETE_FAVORITES, DELETE_FAVORITES_REQUEST_FAILED, SENDING_DELETE_FAVORITES_REQUEST,
} from '../../types/Types';

/** @type { Object } default state */
const defaultState = {
  dFData: '',
  isDFSending: false,
  dfError: false,
  isDFSuccess: false,
};

/**
* dispatched the user data to the store
* @param  { Object } state  default state
* @param  { Object } action dispacthed action from middleware
*/
export default function deleteFavorites(state = defaultState, action = {}) {
  switch (action.type) {
    case SET_DELETE_FAVORITES:
      const data = {};
      data.dFData = action.dFData;
      data.isDFSending = action.isDFSending;
      data.isDFSuccess = action.isDFSuccess;
      data.dfError = action.dfError;
      return { ...state, ...data };

    case SENDING_DELETE_FAVORITES_REQUEST:
      const sendingRequest = {};
      sendingRequest.dFData = action.dFData;
      sendingRequest.isDFSending = action.isDFSending;
      sendingRequest.isDFSuccess = action.isDFSuccess;
      sendingRequest.dfError = action.dfError;
      return { ...state, ...sendingRequest };

    case DELETE_FAVORITES_REQUEST_FAILED:
      const errors = {};
      errors.dFData = action.dFData;
      errors.isDFSending = action.isDFSending;
      errors.isDFSuccess = action.isDFSuccess;
      errors.dfError = action.dfError;
      errors.fMsg = action.fMsg;
      return { ...state, ...errors };
    default: return state;
  }
}
